import React, { useState } from 'react';
import { FormattedMessage } from "react-intl";
import { SelectField } from "../../../shared/SelectField";
import { Label, Row } from "reactstrap";
import { RadioField } from '../../../shared/RadioField';
import { TextField } from '../../../shared/TextField';
import { CUSTOM_EMAIL_TEMPLATES } from '../../../../config/constants';

function SendEmailClientForm(props) {
  const { formikProps } = props;
  const [ test, setTest ] = useState(false);
  let templates = Object.values(CUSTOM_EMAIL_TEMPLATES);

  return (
    <div className="mb-3">
      <Label>
        <FormattedMessage id="components.pages.clients.forms.template" />
      </Label>
      <SelectField
        name="template"
        classNamePrefix="ml-0"
        defaultValue={templates[0]}
        options={templates}
        onChange={(option) => formikProps.setFieldValue('template', option.value )}
      />
      <Label className="mt-3">
        <FormattedMessage id="components.pages.clients.forms.test" />
      </Label>
      <Row className="justify-content-start ml-0 mr-0 d-block">
          <RadioField
            onChange={event => {
              formikProps.setFieldValue('test', event.target.value);
              setTest(true);
            }}
            name="test"
            id="yes"
            checkboxText={<FormattedMessage id="button.yes" />}
            value={"true"}
            defaultChecked={formikProps.values.test}
            className="d-inline-block"
          />
          <RadioField
            onChange={event => {
              props.formikProps.setFieldValue('test', event.target.value);
              setTest(false);
            }}
            name="test"
            id="no"
            checkboxText={<FormattedMessage id="button.no" />}
            value={"false"}
            defaultChecked={formikProps.values.test}
            className="ml-3 d-inline-block"
          />
        </Row>
        {
          test &&
          <>
              <Label className="mt-3">
                <FormattedMessage id="components.pages.clients.forms.firstName" />
              </Label>
              <TextField
                name="firstName"
                value={formikProps.values.firstName}
                classNameFormGroup="m-0"
                onChange={(e) =>
                  formikProps.setFieldValue("firstName", e.target.value )
                }
              />
              <Label className="mt-3">
                <FormattedMessage id="components.pages.clients.forms.email" />
              </Label>
              <TextField
                name="email"
                value={formikProps.values.email}
                classNameFormGroup="m-0"
                onChange={(e) =>
                  formikProps.setFieldValue("email", e.target.value )
                }
              />
          </>
        }
    </div>
  );
}

export { SendEmailClientForm };
